import { AMBIGUOUS_NAME_HEADERS, AUTOMAP_SYNONYMS } from '../constants/automapSynonyms.js';
import { IMPORT_TARGET } from '../constants/importTargets.js';

const normalize = (header) =>
  String(header)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

const SYNONYM_LOOKUP = new Map(
  Object.entries(AUTOMAP_SYNONYMS).flatMap(([target, names]) => names.map((name) => [normalize(name), target])),
);

/**
 * Pre-fills "Imports as" from the headers of the file (Spanish and English). Pure.
 * Each target goes to the FIRST column that matches; later matches fall to Don't import, as
 * does anything unknown. A bare Name/Nombre is a first name when a last name column exists,
 * else a full name.
 *
 * @param {string[]} headers
 * @returns {Record<string, string>} `{ [header]: target | 'skip' }`
 */
export function automapColumns(headers) {
  const guesses = headers.map((header) => SYNONYM_LOOKUP.get(normalize(header)) ?? null);
  const hasLastName = guesses.includes(IMPORT_TARGET.LAST_NAME);
  const taken = new Set();

  return Object.fromEntries(
    headers.map((header, index) => {
      let target = guesses[index];
      if (!target && AMBIGUOUS_NAME_HEADERS.includes(normalize(header))) {
        target = hasLastName ? IMPORT_TARGET.FIRST_NAME : IMPORT_TARGET.FULL_NAME;
      }
      if (!target || taken.has(target)) return [header, IMPORT_TARGET.SKIP];
      taken.add(target);
      return [header, target];
    }),
  );
}
